window.ttx = window.ttx || {};
ttx.portal = ttx.portal || {};

/**
 * 导航模块 — 不依赖路由，通过回调在运行时打开/关闭页面
 *
 * 运行时（transfer/core）加载时通过 onOpen 注册回调，
 * 外部（工作台/菜单）调用 open(params) 触发回调渲染页面。
 */
(function () {
    var _handler = null;
    var _pendingQueue = [];

    /** 运行时注册回调：收到 open 时接管渲染 */
    ttx.portal.onOpen = function (handler) {
        _handler = handler;
        // handler 就绪后，重放之前缓存的点击
        if (_pendingQueue.length) {
            var queue = _pendingQueue.splice(0);
            queue.forEach(function (params) {
                handler(params);
            });
        }
    };

    /** 打开页面 */
    ttx.portal.open = function (params) {
        if (_handler) {
            _handler(params);
        } else {
            // handler 尚未注册（core bundle 还在加载），暂存到队列
            _pendingQueue.push(params);
        }
    };

    /** 关闭当前页面 */
    ttx.portal.close = function () {
        if (_handler) {
            _handler(null);
        }
    };
})();
